import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import ApplicationToggle from './ApplicationToggle';

class VisibleInApplications extends React.Component {
    onChange = appId => {
        const { selectedApplicationsIds, onChange } = this.props;
        // if the user is deselecting the last app, don't do anyting
        // we should not allow the user to update the project witout at least
        // selected application
        const appIdInSelectedAppIds = selectedApplicationsIds.includes(appId);
        if (selectedApplicationsIds.length === 1 && appIdInSelectedAppIds) {
            return;
        }

        if (appIdInSelectedAppIds) {
            onChange(
                selectedApplicationsIds.filter(
                    selectedAppId => selectedAppId !== appId,
                ),
            );
        } else {
            onChange(selectedApplicationsIds.concat([appId]));
        }
    };
    render() {
        const {
            visibleInApplications,
            selectedApplicationsIds,
            classes,
        } = this.props;
        return (
            <div className={classes.wrapper}>
                <span>Apps with access to this project</span>
                {visibleInApplications.map(app => (
                    <ApplicationToggle
                        key={app.id}
                        onClick={this.onChange}
                        isActive={
                            selectedApplicationsIds.indexOf(app.id) !== -1
                        }
                        label={app.name}
                        code={app.id}
                    />
                ))}
            </div>
        );
    }
}

VisibleInApplications.propTypes = {
    visibleInApplications: PropTypes.array.isRequired,
    selectedApplicationsIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: spacing.unit * 4,
    },
});

export default injectSheet(style)(VisibleInApplications);



// WEBPACK FOOTER //
// ./src/components/visibleInApplications/VisibleInApplications.js